
























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

interface Post {
  uid: string
  title: string
  content: string
  createdAt: string
  tags: Array<string>
  image: string
}

interface Description {
  id: string;
  title: string;
  descriptions: Array<Td>;
}
interface Td {
  id: string;
  title: string;
  images: Array<Image>;
  items: Array<string>;
  pres: Array<Pre>;
}

interface Image {
  src: string;
  comment: string;
}
interface Pre {
  src: string;
  comment: string;
}

@Component
export default class GolangComponent extends Vue {
  @Prop()
	private msg!: string;
	private signinStatus = "signed out"
  
	private isActive = "1"

  private uid: string = '?'
  private title: string = '?'
  private content: string = '?'
  private createdAt: string = '?'
  private tags: Array<string> = ['?']
  private image: string = '?'
  
  //private posts: Array<string> = ['AnAKLGcDD8fpYwD1UQhl', 'FvT2sbUSkSASF978fcAw', 'a9FWwIqt4nXdrUfVfssU']
  private posts: Array<Post> = []

  private postIndex = 0
  
  //private posts:Array<Post> = [Post?]

	created() {
		const user = this.$auth.currentUser
		if (user) {
			// User is signed in.
			const email = user.email
			const uid = user.uid
			this.signinStatus = "signed in"
			//window.console.log("created() 2.User is signed in: ")
			//window.console.log("created() 3.uid: " + uid)
			//window.console.log("created() 4.email: " + email)
		} else {
			// No user is signed in.
			this.signinStatus = "signed out"
			window.console.log("created() 5.No user is signed in: ")
			// 単純な遷移
			//this.$router.push('/signin/')
		}
	}

	private text1 = `
	import (
	  "fmt"
	  "context"

	  firebase "firebase.google.com/go"
	  "firebase.google.com/go/auth"

	  "google.golang.org/api/option"
	)

	func main() {
	    opt := option.WithCredentialsFile("xxxx.json")
	    ctx := context.Background()
	    app, err := firebase.NewApp(ctx, nil, opt)
	    if err != nil {
	        fmt.Errorf("error initializing app: %v", err)
	    }
	    client, err := app.Firestore(ctx)
	    if err != nil {
	        fmt.Errorf("error initializing client: %v", err)
	    }
	    defer client.Close()
	    fmt.Println("Firestore connection done")
	}
	`
	private text2 = `
	package main

	import (
	    "fmt"

	    "golang.org/x/net/context"

	    firebase "firebase.google.com/go"
	    "google.golang.org/api/option"
	)

	func main() {
	    // クライアント接続
	    opt := option.WithCredentialsFile("key.json")
	    ctx := context.Background()
	    app, err := firebase.NewApp(ctx, nil, opt)
	    if err != nil {
	        fmt.Errorf("error initializing app: %v", err)
	    }
	    client, err := app.Firestore(ctx)
	    if err != nil {
	        fmt.Errorf("error initializing client: %v", err)
	    }
	    defer client.Close()
	    fmt.Println("Connection done")

	    // 値の取得
	    collection := client.Collection("コレクションID")
	    doc := collection.Doc("ドキュメントID")
	    field, err := doc.Get(ctx)
	    if err != nil {
	        fmt.Errorf("error get data: %v", err)
	    }
	    data := field.Data()
	    for key, value := range data {
	        fmt.Printf("key: %v, value: %v\\n", key, value)
	    }
	}	
	`
	private text3 = `
	type Mixer struct {
		streamers []Streamer
	}
	`
	private text4 = `
	// Streamer is able to stream a finite or infinite sequence of audio samples.
	type Streamer interface {
		// Stream copies at most len(samples) next audio samples to the samples slice.
		//
		// The sample rate of the samples is unspecified in general, but should be specified for
		// each concrete Streamer.
		//
		// The value at samples[i][0] is the value of the left channel of the i-th sample.
		// Similarly, samples[i][1] is the value of the right channel of the i-th sample.
		//
		// Stream returns the number of streamed samples. If the Streamer is drained and no more
		// samples will be produced, it returns 0 and false. Stream must not touch any samples
		// outside samples[:n].
		//
		// There are 3 valid return pattterns of the Stream method:
		//
		//   1. n == len(samples) && ok
		//
		// Stream streamed all of the requested samples. Cases 1, 2 and 3 may occur in the following
		// calls.
		//
		//   2. 0 < n && n < len(samples) && ok
		//
		// Stream streamed n samples and drained the Streamer. Only case 3 may occur in the
		// following calls.
		//
		//   3. n == 0 && !ok
		//
		// The Streamer is drained and no more samples will come. If Err returns a non-nil error, only
		// this case is valid. Only this case may occur in the following calls.
		Stream(samples [][2]float64) (n int, ok bool)

		// Err returns an error which occurred during streaming. If no error occurred, nil is
		// returned.
		//
		// When an error occurs, Streamer must become drained and Stream must return 0, false
		// forever.
		//
		// The reason why Stream doesn't return an error is that it dramatically simplifies
		// programming with Streamer. It's not very important to catch the error right when it
		// happens.
		Err() error
	}
	`

	private contents1: Description = {
		id: "1",
		title: "「Go言語」の概要",
		descriptions: [
		 {id: "1",
		  title: "「Go言語」の特徴",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"「Go言語」は、新しい時代の「C言語」です。",
		  	"Go言語とは、検索エンジンとして馴染み深いGoogleが開発したプログラミング言語です。",
		  	"どのような言語なのかを一言で表せば、「シンプルかつ高速な処理が可能なプログラミング言語」で、有名なWebサービスの開発やサーバの構築などにも用いられています。",
		  	"世界的な動画配信サービスの「YouTube」やフリマアプリとして知られる「メルカリ」、国内有数のグルメサイトとして名高い「ぐるなび」など、実際にGo言語を採用しているサービスやWebアプリは少なくありません。",
		  	"またGo言語は、シンプルな構文である分「誰が読んでも分かるプログラムを書きやすい」という特徴があります。",
		  	"そのため、複数人のエンジニアで並行してコーディングが行いやすく、用途を問わず「規模の大きいシステム開発に最適な言語」なのです。",
		  	"処理速度の速さも相まって、同時にコーディングをしても作業効率が落ちにくい点は、Go言語の大きな利点と言えるでしょう。",
		    ],
		  pres: [],
		 }, // end of id=1
		 {id: "2",
		  title: "「Module」の機能",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"Modules は、依存モジュール管理ツールです。",
		  	"Go言語 1.11 から標準で使えるようになりました。",
		  	"以下のような機能を持っています。",
		  	" ・依存モジュールの自動検知",
		  	" ・依存モジュールのバージョン固定、バージョンアップ検知",
		  	"依存モジュールの情報は go.mod と go.sum という名前のファイルに記載されます。",
		  	"これらのファイルを git などでバージョン管理することによって、依存モジュールとそのバージョンを明確にすることができます。",
		  	"Ruby の Bundler や Node.js の npm のようなものですね。",

		    ],
		  pres: [],
		 }, // end of id=2

		]
	} // end of contents1

	private contents2: Description = {
		id: "2",
		title: "Fyne",
		descriptions: [
		 {id: "1",
		  title: "Go言語」のGUIである「Fyne」",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"TODO",
		  ],
		  pres: [],
		 }, // end of id=1
		]
	} // end of contents2

	private contents3: Description = {
		id: "3",
		title: "GOCV",
		descriptions: [
		 {id: "1",
		  title: "「Go言語」でOpneCVを活用する「GOCV」",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"TODO",
		  ],
		  pres: [],
		 }, // end of id=1
		]
	} // end of contents3

	private contents4: Description = {
		id: "4",
		title: "Firestore",
		descriptions: [
		 {id: "1",
		  title: "Firebase共通鍵の入手",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"Firebaseコンソールへログイン",
		  	"「設定」→「プロジェクトの設定」で設定画面を表示",
		  	"「サービスアカウント」タブを押し、Firebase Admin SDKを表示する",
		  	"Admin SDK 構成スニペットでGoを選択",
		  	"【新しい秘密鍵の生成】ボタンから秘密鍵(json)をダウンロード",
		  ],
		  pres: [],
		 }, // end of id=1
		 {id: "2",
		  title: "クライント接続",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"以下に利用例を示す。",
		  ],
		  pres: [{src: this.text1, comment: ""},],
		 }, // end of id=2
		 {id: "3",
		  title: "値の取得",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"以下に利用例を示す。",
		  ],
		  pres: [{src: this.text2, comment: ""},],
		 }, // end of id=3
		]
	} // end of contents4

	private contents5: Description = {
		id: "5",
		title: "Beep",
		descriptions: [
		 {id: "1",
		  title: "「Go言語」で音声を利用する",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"Mixer構造体：Streamerの配列です。",
		  	"Streamerインタフェース：Stream()関数を持ちます。",
		  	"Stream()関数：Sample([][2]float64)を返します。",
		  ],
		  pres: [
		   {src: this.text3, comment: "①Mixer構造体の定義"},
		   {src: this.text4, comment: "②Streamerインタフェースの定義"},
		  ],
		 }, // end of id=1
		]
	} // end of contents4

} // end of export
